// utils/api/UserApi.js

import { apiCall } from './ApiUtils';

export const userApi = {
  // User stats (class-aware)
  getUserStats: (username, classContext = null) => 
    apiCall(`/user-stats/${encodeURIComponent(username)}`, {}, classContext),
  
  // Feedback (class-aware)
  getUserFeedback: (username, classContext = null) => {
    const encodedUsername = encodeURIComponent(username);
    console.log(`[UserApi] getUserFeedback: original="${username}", encoded="${encodedUsername}"`);
    return apiCall(`/feedback/${encodedUsername}`, {}, classContext);
  },
  
  // Notifications (class-aware)
  getUserNotifications: (username, classContext = null) => {
    const encodedUsername = encodeURIComponent(username);
    console.log(`[UserApi] getUserNotifications: original="${username}", encoded="${encodedUsername}"`);
    return apiCall(`/notifications/${encodedUsername}`, {}, classContext);
  },

  // Users list
  getUsersList: () => apiCall('/users-list'),
  
  // Generate feedback with class context
  generateFeedback: (feedbackData, classContext = null) => 
    apiCall('/generate-feedback', {
      method: 'POST',
      body: JSON.stringify(feedbackData)
    }, classContext),
  
  // Submit final work with class context
  submitFinalWork: (submissionData, classContext = null) => 
    apiCall('/final-submission', {
      method: 'POST',
      body: JSON.stringify(submissionData)
    }, classContext),
};